import { configureStore } from '@reduxjs/toolkit';
import { profileApi } from './features/profile/api/profileApi';
import authReducer from './features/auth/slices/authSlice';
import inactivityScreenReducer from './features/auth/slices/inactivityScreenSlice';
import notificationReducer from './features/notification/slices/notificationSlice';
import { userManagementApi } from './features/user-management/api/userManagementApi';
import eConsentPlatformReducer from './features/e-consent/api/eConsentPlatformSlice';
import { eConsentPharmaNavigatorApi } from './features/e-consent/api/eConsentPharmaNavigatorApi';
import { eConsentPlatformApi } from './features/e-consent/api/eConsentPlatformApi';
import doctorsApi from './features/doctors/api/doctorsApi';
import { productsApi } from './features/products/api/productsApi';
import { tenantsApi } from './features/tenant/tenantApi';
import { activityApi } from './features/activity/api/activityApi';
import { questionApi } from './features/questions/api/questionApi';
import { bannerApi } from './features/banner/api/bannerApi';

export const rootReducer = {
    [profileApi.reducerPath]: profileApi.reducer,
    [userManagementApi.reducerPath]: userManagementApi.reducer,
    [eConsentPharmaNavigatorApi.reducerPath]: eConsentPharmaNavigatorApi.reducer,
    [eConsentPlatformApi.reducerPath]: eConsentPlatformApi.reducer,
    [doctorsApi.reducerPath]: doctorsApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [tenantsApi.reducerPath]: tenantsApi.reducer,
    [activityApi.reducerPath]: activityApi.reducer,
    [questionApi.reducerPath]: questionApi.reducer,
    [bannerApi.reducerPath]: bannerApi.reducer,
    eConsentPlatform: eConsentPlatformReducer,
    auth: authReducer,
    notifications: notificationReducer,
    inactivityScreen: inactivityScreenReducer,
};

export const sharedMiddleware = [
    profileApi.middleware,
    userManagementApi.middleware,
    eConsentPharmaNavigatorApi.middleware,
    eConsentPlatformApi.middleware,
    doctorsApi.middleware,
    productsApi.middleware,
    tenantsApi.middleware,
    activityApi.middleware,
    questionApi.middleware,
    bannerApi.middleware,
];

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sharedMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
